export const SELECT_INSURANCE_OFFER = 'SELECT_INSURANCE_OFFER';
export const SELECT_USER_ASSURANCE = 'SELECT_USER_ASSURANCE';